<script>
import lottie from 'lottie-web';

export default {
  props: {
    name: {
      type: String,
      default: () => `lottie-${Math.random()}`,
    },
    width: {
      type: String,
      default: () => '200px',
    },
    height: {
      type: String,
      default: () => '200px',
    },
    background: {
      type: String,
      default: 'transparent',
    },
    loop: {
      type: [Boolean, Number],
      default: () => false,
    },
    autoplay: {
      type: Boolean,
      default: () => true,
    },
    renderer: {
      type: String,
      default: () => 'svg',
    },
    path: {
      type: String,
      default: () => null,
    },
    animationData: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      style: {
        width: this.width,
        height: this.height,
        background: this.background,
      },
    };
  },
  mounted() {
    this.loadAnimation();
  },
  methods: {
    loadAnimation() {
      const anim = lottie.loadAnimation({
        container: this.$refs.animContainer,
        name: this.name,
        renderer: this.renderer,
        loop: this.loop,
        autoplay: this.autoplay,
        width: this.width,
        height: this.height,
        path: this.path,
        animationData: this.animationData,
      });

      this.$emit('animControl', anim);
    },
  },
};
</script>

<template>
  <div ref="animContainer" :style="style"></div>
</template>
